import * as React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import { CallBackType, SubPageType } from 'pages/MultiWidgetPage/MultiwidgetBase/MultiwidgetTypes/MultiWidgetCallBackProps';
import styles from './MinimumOrderQuantity.css';
export var EffectType;
(function (EffectType) {
    EffectType["BLINK"] = "BLINK";
    EffectType["HIGHLIGHT"] = "HIGHLIGHT";
})(EffectType || (EffectType = {}));
const modalSettings = {
    classNames: {
        dialog: styles['moq-info-modal']
    }
};
export default class MinimumOrderQuantity extends React.Component {
    constructor() {
        super(...arguments);
        this.handleLinkTextClick = () => {
            const { data, handleShowSubPage } = this.props;
            const moqInfoUrl = get(data, ['announcement', 'button', 'action', 'url']);
            if (handleShowSubPage && moqInfoUrl) {
                handleShowSubPage({
                    type: CallBackType.LOAD_SUBPAGE,
                    subPageType: SubPageType.OPEN_MODAL,
                    pageUri: moqInfoUrl,
                    modalSettings
                });
            }
        };
    }
    render() {
        const { data, className, effectType } = this.props;
        const title = get(data, ['announcement', 'title', 'value', 'text']) || '';
        const subTitle = get(data, ['announcement', 'subTitle', 'value', 'text']) || '';
        const linkText = get(data, ['announcement', 'button', 'value', 'richText', 'text']);
        const message = title + subTitle;
        return (<SimpleMinimumOrderQuantity message={message} linkText={linkText} effectType={effectType} className={className} handleLinkTextClick={this.handleLinkTextClick}/>);
    }
}
export function SimpleMinimumOrderQuantity(props) {
    const { message, linkText, effectType, className, handleLinkTextClick } = props;
    if (!message) {
        return null;
    }
    return (<div className={cx(styles['min-quantity'], { [styles['blink']]: effectType === EffectType.BLINK }, { [styles['highlight']]: effectType === EffectType.HIGHLIGHT }, className)}>
			{message}

			{linkText && handleLinkTextClick && (<span className={styles['know-more']} onClick={handleLinkTextClick}>
					{linkText}
				</span>)}
		</div>);
}
